import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PlayerPlace from './leftSide/playerPlace/PlayerPlace';
import Description from './leftSide/description/Description';
import FileTable from './rightSide/filesTable/FileTable';
import ToolBarDeviceOne from './leftSide/toolBar/toolBarDeviceOne';
import './style.css';
import MenuRS from './rightSide/menu/MenuRS';
import ToolBarRS from './rightSide/toolbarRS/ToolBarRS';
import InfoBar from './leftSide/infoBar/InfoBar';
import { useSelectedDevice } from '../../store/devices/SelectedDevice';
import { useMenuRSStateStore } from '../../store/rightSideMenuState/menuRSStateStore';
import LocationMap from '../locationMap/LocationMap';

import { Layout } from 'antd';
import { useFileSelectionStore } from '../../store/devices/useSelectedRowKeysFilesRS';
import IconLeftMenuFooter from '../icons/iconLeftMenu/IconLeftMenuFooter';

import ButtonDOFooterDelete from '../buttons/buttonLeftMenu/ButtonDOFooterDelete';
import { useButtonDeleteFromDOF } from '../../store/devices/useButtonsDeleteFromDOF';
import { useFilesStore } from '../../store/devices/FilesDevicesFromDB';
import { useFileCurrentTypeStore } from '../../store/devices/fileCurrentType';
import { useFilterFileStore } from '../../store/devices/fileFilterStote';
import { useAuthStore } from '../../store/auth/auth';
import { useRecordingState } from './leftSide/toolBar/api/recordingState';

const { Content, Footer } = Layout;

interface DeviceOneProps {
    selectedFileUID?: string;
}

interface FileData {
    deviceUID: string;
    start: string;
    end: string;
    rating?: number[];
}

const DeviceOne: React.FC<DeviceOneProps> = ({ selectedFileUID }) => {
    const { selectedDevice } = useSelectedDevice();
    const { selectedStateMenuRS, setSelectedStateMenuRS } = useMenuRSStateStore();
    const { selectedFiles, clearSelectedFiles } = useFileSelectionStore();
    const { setIsDeleteDeviceModal } = useButtonDeleteFromDOF();
    const { files, fetchFiles, resetFiles, hasMore, pagination, setPagination } = useFilesStore();
    const { fileFilterStore } = useFilterFileStore();
    const { user, SmartDVRToken } = useAuthStore();
    const [isLoading, setIsLoading] = useState(false);
    const { recordingType, setRecordingType } = useRecordingState();
    const { fileType } = useFileCurrentTypeStore();

    const filteredCount = useMemo(() => {
        return fileType === 'all'
            ? files.length
            : files.filter((file) => file.fileType === fileType).length;
    }, [files, fileType]);

    const showDeleteDeviceModal = () => {
        setIsDeleteDeviceModal(true);
    };

    const fetchFilteredFiles = useCallback(async () => {
        if (!selectedDevice) return;

        const deviceUID = selectedDevice.UID;
        let dateStart = '2024-02-27T20:22:49+05:00';
        let dateEnd = '2099-12-14T23:59:59+05:00';
        let rating: number[] = [];
        console.log(Boolean(fileFilterStore.dateStart));
        // if (fileFilterStore) {
        //     dateStart = fileFilterStore.dateStart || dateStart;
        //     dateEnd = fileFilterStore.dateEnd || dateEnd;
        //     if (fileFilterStore.rating.length > 0) {
        //         rating = fileFilterStore.rating.map(Number);
        //     }
        // }

        const startDate = new Date(dateStart);
        const endDate = new Date(dateEnd);
        const isoStartDate = startDate.toISOString();
        const isoEndDate = endDate.toISOString();
        console.log(startDate, isoStartDate);

        const fileData: FileData = {
            deviceUID,
            start: isoStartDate,
            end: isoEndDate,
            // rating: rating.length > 0 ? rating : undefined,
        };

        if (user && SmartDVRToken) {
            setIsLoading(true);
            try {
                console.log('1');
                await fetchFiles(fileData, SmartDVRToken, user.login, 1, pagination.pageSize);
            } finally {
                setIsLoading(false);
            }
        }
    }, [selectedDevice, fileFilterStore, SmartDVRToken, user, fileType]);

    const loadDeviceFiles = useCallback(async () => {
        if (!selectedDevice || !user || !SmartDVRToken) return;

        await fetchFiles(
            {
                deviceUID: selectedDevice.UID,
                start: undefined,
                end: undefined,
                rating: undefined,
                fileType: undefined,
            },
            SmartDVRToken,
            user.login,
            1,
            50,
        );
    }, [selectedDevice, user, SmartDVRToken, fetchFiles]);

    // Принудительное обновление после изменения recordingType
    // useEffect(() => {
    //     if (!recordingType) {
    //         // После остановки записи делаем дополнительное обновление
    //         setTimeout(() => fetchFilteredFiles(), 3000);
    //     }
    // }, [recordingType, fetchFiles]);

    useEffect(() => {
        setSelectedStateMenuRS('map');
        loadDeviceFiles();

        return () => {
            setSelectedStateMenuRS('map');
        };
    }, [selectedDevice?.UID]); // Срабатывает при изменении UID устройства

    return (
        <>
            <Layout
                className="device-one-layout"
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
            >
                {/* Левая часть - плеер и информация об устройстве */}
                <Layout className="left-side-layout">
                    <Content className="left-side-content">
                        <ToolBarDeviceOne
                            device={selectedDevice}
                            onRecordingStateChange={setRecordingType}
                            refreshFiles={fetchFilteredFiles}
                        />
                        <PlayerPlace device={selectedDevice} />
                        <InfoBar device={selectedDevice} />
                        <Description device={selectedDevice} />
                    </Content>
                </Layout>

                {/* Правая часть - файлы/карта */}
                <Layout className="right-side-layout">
                    <Content className="right-side-content">
                        <MenuRS fileCount={filteredCount} />
                        <ToolBarRS device={selectedDevice} />
                        {selectedStateMenuRS === 'map' ? (
                            <LocationMap device={selectedDevice} />
                        ) : (
                            <FileTable device={selectedDevice} />
                        )}
                    </Content>

                    <Footer
                        className="right-side-footer"
                        style={{
                            display: Object.entries(selectedFiles).length ? 'flex' : 'none',
                        }}
                    >
                        <div className="table-footer">
                            <span className="count-device-footer">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconLeftMenuFooter onClick={clearSelectedFiles} />
                                    <span className="footer-text">
                                        Выбрано: {Object.entries(selectedFiles).length}
                                    </span>
                                </div>
                            </span>
                            <div>
                                <ButtonDOFooterDelete onClick={showDeleteDeviceModal} />
                            </div>
                        </div>
                    </Footer>
                </Layout>
            </Layout>
        </>
    );
};

export default DeviceOne;
